import { runtimeConfig } from "@/config/runtime"

function trimTrailingSlash(value: string): string {
  return value.replace(/\/+$/, "")
}

export function getLkPublicUrl(): string {
  const fromQuery = new URLSearchParams(window.location.search).get("lkUrl")
  if (fromQuery) {
    return trimTrailingSlash(fromQuery)
  }

  if (runtimeConfig.lkUrl) {
    return trimTrailingSlash(runtimeConfig.lkUrl)
  }

  return window.location.origin
}

function getTopWindow(): Window {
  try {
    return window.top ?? window
  } catch {
    return window
  }
}

export function redirectToLk(path: string): void {
  const normalized = path.startsWith("/") ? path : `/${path}`
  getTopWindow().location.assign(`${getLkPublicUrl()}${normalized}`)
}

export function getPaymentReturnUrl(): string {
  return `${getLkPublicUrl()}/payments`
}
